import React from "react";
import { Dialog } from "../../../ui";
import { useSourceDetail } from "../hooks/useSourceDetail";
import { SourceDetailView } from "./SourceDetailView";

interface SourceDetailModalProps {
  source: { type: string; id: string };
  onClose: () => void;
}

export function SourceDetailModal({ source, onClose }: SourceDetailModalProps) {
  const { data, loading, error } = useSourceDetail(source.type, source.id);
  const title = `Source: ${source.type.replace(/_/g, " ")}`;

  return (
    <Dialog title={title} onClose={onClose} ariaLabelledBy="source-detail-modal-title">
      {loading && (
        <p className="text-sm text-muted-foreground animate-pulse">Loading…</p>
      )}
      {error && <p className="text-sm text-destructive">{error}</p>}
      {!loading && !error && data && <SourceDetailView data={data} />}
    </Dialog>
  );
}
